import { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
// import "../../../../assets/UFC_DC_RF_V1/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf/pdf.worker.min.js`;

const LoaNew = ({close}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 0.9);

  const onLoadSuccess = ({ numPages }) => {
    console.log("Number of pages loaded:", numPages);
    
    setNumPages(numPages);
  };

    const updatePageWidth = () => {
      const modalMaxWidth = 800; // Set a max width for the modal
      const newWidth = Math.min(window.innerWidth * 0.9, modalMaxWidth);
        setPageWidth(newWidth); // Only update state if the width has changed
      
    };
  

    useEffect(() => {
      updatePageWidth(); // Update on component mount
      console.log("Update on component mount");
      window.addEventListener("resize", updatePageWidth); // Update on window resize
      return () => window.removeEventListener("resize", updatePageWidth);
    }, []);

  return (
    <>
      <div className={`PrivacyCustom text-start `}>
        <a className="btn btn-link fnt-sml">
          Letter of Authority
        </a>

        <div
          className={`modal fade blackover show`}
          id="loa"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg over_craft">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-header  border border-0 pb-0">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={close}
                    style={{ backgroundColor: "red" }}
                  ></button>
                </div>
                <div className="container-sm my-4 Cpa_page_style d-flex align-items-center justify-content-center">
                  <Document
                    file="/pdf/UFC_DC_RF_V1/Charterhouse_Claims_Letter_of_Authority-Car_Finance_2.pdf"
                    onLoadSuccess={onLoadSuccess}
                    onLoadError={(error) =>
                      console.error("Error loading PDF:", error)
                    }
                  >
                    {Array.from(new Array(numPages), (_, index) => (
                      <Page
                        key={index}
                        pageNumber={index + 1}
                        width={pageWidth}
                      />
                    ))}
                  </Document>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoaNew;
